import { BarDatum, BarSeries } from '../bar-chart/bar-chart';
import { TrendPoint } from '../trend-line/trend-line';
import { chartTokens } from '../charts/chart-tokens';
import { automatedManualOf } from '../charts/trend-split';
import {
  AutomationDashboardSummaryMock,
  TrendDataPointMock
} from '../charts/chart-types';
import { AutomationTrendChartProps } from './automation-trend-chart';

/**
 * Two-series stacked layout matching cmx-argus: automated (high+rule combined)
 * stacked below manual (low+rule combined), mirroring AutomationTrendTile.jsx:67-73.
 */
export const AUTOMATION_TREND_SERIES: BarSeries[] = [
  {
    key: 'automated',
    label: 'Automated',
    color: chartTokens.series.automated
  },
  {
    key: 'manual',
    label: 'Manual',
    color: chartTokens.series.manual
  }
];

const trendPointToBar = (d: TrendDataPointMock): BarDatum => ({
  category: d.date,
  values: automatedManualOf(d)
});

const trendPointToLine = (d: TrendDataPointMock): TrendPoint => ({
  date: d.date,
  value: (d.total_automated ?? 0) + (d.total_manual ?? 0),
  rate: d.automation_rate ?? 0
});

export interface ToAutomationTrendChartOptions {
  ariaLabel?: string;
}

type ChartShapeProps = Pick<
  AutomationTrendChartProps,
  'data' | 'series' | 'barData' | 'ariaLabel'
>;

/**
 * Map an `/api/automation-dashboard/summary` response into the chart-shape
 * subset of `<AutomationTrendChart>` props (data + series + barData). The
 * container (CDMX-14949) layers in the filter values, option lists, and
 * change handlers separately.
 */
export const toAutomationTrendChartProps = (
  response: AutomationDashboardSummaryMock,
  options: ToAutomationTrendChartOptions = {}
): ChartShapeProps => {
  const trend = response.data.trend ?? [];
  return {
    data: trend.map(trendPointToLine),
    series: AUTOMATION_TREND_SERIES,
    barData: trend.map(trendPointToBar),
    ariaLabel: options.ariaLabel ?? 'Automation trend'
  };
};
